var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createStyles } from 'antd-style';
export default createStyles(function (_ref) {
  var css = _ref.css,
    prefixCls = _ref.prefixCls;
  return {
    customTooltip: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      .", "-tooltip-inner {\n        padding: 4px 8px;\n      }\n      .", "-tooltip-arrow::after {\n        box-shadow: none;\n        width: 11.313708498984761px;\n        height: 11.313708498984761px;\n      }\n      .", "-tooltip-arrow::before {\n        clip-path: polygon(0% 100%, 100% 100%, 50% 0%);\n      }\n    "])), prefixCls, prefixCls, prefixCls)
  };
});